import { Grid } from '@mui/material'
import { TimeClockType } from 'models'
import { useCallback } from 'react'
import EachTimeClockMenu from './EachTimeClockMenu'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import AlarmOffRoundedIcon from '@mui/icons-material/AlarmOffRounded'
import FastfoodRoundedIcon from '@mui/icons-material/FastfoodRounded'
import { enableTimeClockMenuLogic } from './timeClockMenuLogic'
import { useTimeClockPopupContext } from './TimeClockPopupProvider'

export interface ITimeClockMenu {
    name: string
    icon: any
    color: string
    type: TimeClockType
    disabled: boolean
}

const TimeClockMenus = () => {
    const { timeClock, saveActionOfUserTimeClock } = useTimeClockPopupContext()

    const timeClockMenus = useCallback(() => {
        const latestStatus = timeClock?.latestStatus || TimeClockType.ClockOut

        const startOrEndBreak =
            latestStatus === TimeClockType.StartBreak
                ? TimeClockType.EndBreak
                : TimeClockType.StartBreak
        const startOrEndMealBreak =
            latestStatus === TimeClockType.StartMealBreak
                ? TimeClockType.EndMealBreak
                : TimeClockType.StartMealBreak

        return [
            {
                name: 'CLOCK-IN',
                icon: <AccessTimeIcon />,
                color: 'primary',
                type: TimeClockType.ClockIn,
                disabled:
                    !timeClock ||
                    !enableTimeClockMenuLogic(
                        TimeClockType.ClockIn,
                        latestStatus,
                    ),
            },
            {
                name: 'CLOCK-OUT',
                icon: <AccessTimeIcon />,
                color: 'error',
                type: TimeClockType.ClockOut,
                disabled:
                    !timeClock ||
                    !enableTimeClockMenuLogic(
                        TimeClockType.ClockOut,
                        latestStatus,
                    ),
            },
            {
                name:
                    latestStatus === TimeClockType.StartBreak
                        ? 'END BREAK'
                        : 'ON BREAK',
                icon: <AlarmOffRoundedIcon />,
                color: 'warning',
                type: startOrEndBreak,
                disabled:
                    !timeClock ||
                    !timeClock.useBreak ||
                    !enableTimeClockMenuLogic(startOrEndBreak, latestStatus),
            },
            {
                name:
                    latestStatus === TimeClockType.StartMealBreak
                        ? 'END MEAL BREAK'
                        : 'ON MEAL BREAK',
                icon: <FastfoodRoundedIcon />,
                color: 'secondary',
                type: startOrEndMealBreak,
                disabled:
                    !timeClock ||
                    !timeClock.useMealBreak ||
                    !enableTimeClockMenuLogic(
                        startOrEndMealBreak,
                        latestStatus,
                    ),
            },
        ] as ITimeClockMenu[]
    }, [timeClock])

    const onClickMenu = useCallback(
        (menu: ITimeClockMenu) => {
            saveActionOfUserTimeClock(menu.type)
        },
        [saveActionOfUserTimeClock],
    )

    return (
        <Grid
            container
            item
            xs={12}
            spacing={2}
            sx={{ minHeight: '100%', px: 2, pb: 1 }}
        >
            {timeClockMenus().map((t, index) => (
                <EachTimeClockMenu
                    onClickEachMenu={() => onClickMenu(t)}
                    menu={t}
                    key={t.name}
                />
            ))}
        </Grid>
    )
}

export default TimeClockMenus
